const HEX = /^#([0-9a-f]{6})$/i;

export const isHexColor = (value) => typeof value === 'string' && HEX.test(value);

const toRgb = (hex) => {
    const n = parseInt(hex.slice(1), 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

export const withAlpha = (hex, alpha) => {
    const [r, g, b] = toRgb(hex);
    return `rgba(${r},${g},${b},${alpha})`;
};

// WCAG luminance → readable text colour on a filled background.
export const readableTextOn = (hex) => {
    const [r, g, b] = toRgb(hex).map((c) => {
        const s = c / 255;
        return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
    });
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return luminance > 0.4 ? '#1A1A1A' : '#FFFFFF';
};
